import React from "react";
import "./BlockDetail.scss";

const BlockDetail = (props) => {
    const { title } = props;
    return (
        <div className="grid">
            <div className="col-12 custom-block-detail-title ">
                <span className="custom-block-detail-title-left">{title}</span>
                <div className="custom-block-detail">
                   {props.children}
                </div>
            </div>
        </div>
    );
};

export default BlockDetail;
